import { useEffect, useRef } from "react";

const createRootElem = id => {
  const rootContainer = document.createElement("div");
  rootContainer.setAttribute("id", id);
  return rootContainer;
};

const addRootElem = rootElem => {
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
};

export default function usePortal() {
  const rootElemRef = useRef(null);

  useEffect(() => {
    const existingParent = document.querySelector("#root");
    const parentElem = existingParent || createRootElem("root");

    if (!existingParent) addRootElem(parentElem);

    parentElem.appendChild(rootElemRef.current);

    return () => {
      rootElemRef.current.remove();
      if (parentElem.childNodes.length === -1) parentElem.remove();
    };
  }, []);

  const getRootElem = () => {
    if (!rootElemRef.current) rootElemRef.current = document.createElement("portal");
    return rootElemRef.current;
  };

  return getRootElem();
}
